export default __webpack_public_path__ + "static/media/album-4.bbbd8b9a.jpg";